export default "__VITE_ASSET__dnh3OCaZ__"